// Support: Autocomplete

import React, { FC } from 'react';
import { getIn } from 'formik';

export const withAutcompleteFormik = (Component: FC<any>) => (props: any) => {
	const { field, form, ...rest } = props;
	const touched = getIn(form.touched, field.name);
	const error = getIn(form.errors, field.name);
	return (
		<Component
			{...field}
			{...rest}
			form={form}
			error={!!touched && !!error ? error : undefined}
		/>
	);
};

export default withAutcompleteFormik;
